import React, { useEffect, useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../../../policy/fragments/heading";
import { Link, useHistory, useParams } from "react-router-dom";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useIntl } from "react-intl";
import { action_fetch_order_detail } from "../../../../../../../store/actions/pages/customer";
import { useQuery } from "../../../../../../hooks/common";
import { useStore, useSelector } from "react-redux";
import MeSkeleton from '../skeleton/index';
import OrderDetailMessage from "../fragments/order-detail-message";
import OrderTotalDetail from "../fragments/order-total-detail";
import ShippingDetail from "../fragments/shipping-detail";
import OrderPackages from '../fragments/order-package';
import OrderRecommend from "../fragments/order-recommend";
import OrderFixedFooter from "../fragments/order-fixed-footer";
import OrderOfflineModal from "../fragments/order-offline-modal";
import OrderServiceReturn from "../fragments/order-service-return";
import { OrderStatusBtnLink } from "../../list/fragments/order-item/normal";
import { TOTAL_STATUS_UNPAID } from "../../../../utils/constant";
import { setOrderDetail } from "../../../../../../../store/actions/pages/customer";
import { useDispatch } from "react-redux";


const OrderDetail = props =>{
    useStyles(cls);
    const store = useStore();
    const params = useParams();
    const query = useQuery();
    const Intl = useIntl();
    const dispatch = useDispatch();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { orderDetail, orderDetailEmpty, customer } = pageCustomer;

    const history = useHistory();

    useEffect(async () => {
        window?.scrollTo(0, 0);

        if (window.__INITIAL_STATE__) {
              // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            await OrderDetail.fetchData(store, params, query)
        }

        if(orderDetailEmpty){
            history.replace('/user/order/all');
        }
    }, []);


    useEffect(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('EventEnter', {
                page: 'order',
                orderId: params?.orderId
            })
        }

        return () =>{
            dispatch(setOrderDetail(null));
        }
    }, []);

    // 0：正常销售单，1：重发单
    const isNormalOrder = useMemo(() =>{
        return orderDetail?.type !== 1;
    }, [orderDetail]);

    return <div className={cls.OrderDetail}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "order_details", defaultMessage: "Order Details" })} 
            rightSlot={
                <Link to={`/user/faq/support-ticket?id=${params.orderId}`} className={cls.RightIcon}>
                    <Iconfont className={cls.Icon}>&#xe716;</Iconfont>
                </Link>
            }
        />

        {
            orderDetail ? <React.Fragment>
                <OrderDetailMessage orderDetail={orderDetail} customer={customer} />

                {
                    orderDetail?.fulfillmentStatus === TOTAL_STATUS_UNPAID && <ShippingDetail orderDetail={orderDetail} />
                }

                <OrderPackages orderDetail={orderDetail} isNormalOrder={isNormalOrder} />

                <OrderTotalDetail orderDetail={orderDetail} />

                <OrderServiceReturn orderDetail={orderDetail} />
                
                {
                    orderDetail?.fulfillmentStatus !== TOTAL_STATUS_UNPAID && <React.Fragment>
                        <ShippingDetail orderDetail={orderDetail} />

                        <OrderRecommend orderId={orderDetail.id} />
                    </React.Fragment>
                }

                <OrderFixedFooter>
                    <OrderStatusBtnLink isDetail orderItem={orderDetail} />
                </OrderFixedFooter>

                <OrderOfflineModal orderDetail={orderDetail} />
            </React.Fragment> : <MeSkeleton />
        }
    </div>
}

OrderDetail.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_order_detail(params?.orderId, headers))
}

export default OrderDetail;

